
import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import CreateLicenseForm, { LicenseFormValues } from './CreateLicenseForm';

interface CreateLicenseDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreateLicense: (data: LicenseFormValues) => Promise<void>;
  isCreatingLicense: boolean;
  trigger?: React.ReactNode;
}

const CreateLicenseDialog: React.FC<CreateLicenseDialogProps> = ({
  open,
  onOpenChange,
  onCreateLicense,
  isCreatingLicense,
  trigger
}) => {
  const handleSubmit = async (data: LicenseFormValues) => {
    try {
      await onCreateLicense(data);
      onOpenChange(false);
    } catch (error) {
      console.error('Failed to create license:', error);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {trigger && <DialogTrigger asChild>{trigger}</DialogTrigger>}
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Create New License Key</DialogTitle>
          <DialogDescription>
            Generate a new license key for a Super Admin instance
          </DialogDescription>
        </DialogHeader>
        
        <CreateLicenseForm 
          onSubmit={handleSubmit} 
          isCreatingLicense={isCreatingLicense} 
        />
      </DialogContent>
    </Dialog>
  );
};

export default CreateLicenseDialog;
